<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
export let title = '403 — Zugriff verweigert';
export let message = 'Sie haben keine Berechtigung, diese Seite zu öffnen.';
const goHome = () => {
  window.location.href = '/';
};
</script>

<div class="forbidden">
    <h1>{title}</h1>
    <p>{message}</p>
    <button on:click={goHome}>Zur Startseite</button>
</div>

<style>
    .forbidden {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 24px;
        margin: 80px auto 120px auto;
        max-width: 720px;
        text-align: center;
    }

    h1 {
        font-size: 1.8rem;
        margin-bottom: 8px;
    }

    p {
        opacity: 0.9;
        margin-bottom: 16px;
    }

    button {
        background-color: var(--main-color, #3498db);
        color: white;
        border: none;
        padding: 10px 18px;
        border-radius: 4px;
        cursor: pointer;
        font-weight: 500;
    }

    button:hover {
        background-color: var(--sec-color, #2980b9);
    }
</style>
